import app from '../app/app'
import { post } from 'tools/request'
const integration = {
	login(username, password) {
		const authResponse = post('/api/federate/login', {
			data: {
				username,
				password,
				site: 'docdata',
			}
		})
		return authResponse
	},
	logout() {
		$.ajax('https://federate.doctorevidence.com/api/logout', {
			headers: {
				Accept: 'application/json',
			},
			xhrFields: {
				withCredentials: true,
			},
		})
		return post('/api/federate/logout')
	}
}
export default integration
